import { AlertTriangle, Users } from 'lucide-react';

interface ScheduleUtilizationSummaryProps {
  averageUtilization: number;
  teamsOverCapacity: number;
  totalTeams: number;
  isLoading?: boolean;
}

export function ScheduleUtilizationSummary({
  averageUtilization,
  teamsOverCapacity,
  totalTeams,
  isLoading = false,
}: ScheduleUtilizationSummaryProps) {
  // Keep rendering during the initial load so the summary's position is
  // stable; only hide once we know there are genuinely no teams.
  if (totalTeams === 0 && !isLoading) return null;

  const avgColor =
    averageUtilization > 100
      ? 'text-red-600 dark:text-red-400'
      : averageUtilization >= 90
        ? 'text-yellow-700 dark:text-yellow-400'
        : 'text-green-700 dark:text-green-400';

  return (
    <div className="flex items-center gap-4 px-3 py-2 bg-card border border-border rounded-md text-sm">
      <div className="flex items-center gap-2">
        <Users className="w-4 h-4 text-muted-foreground" />
        <span className="text-muted-foreground">Avg utilisation:</span>
        <span className={`font-semibold tabular-nums ${avgColor}`}>
          {isLoading ? '…' : `${Math.round(averageUtilization)}%`}
        </span>
      </div>
      {teamsOverCapacity > 0 && (
        <div className="flex items-center gap-1.5 text-red-600 dark:text-red-400">
          <AlertTriangle className="w-4 h-4" />
          <span className="font-medium">
            {teamsOverCapacity} of {totalTeams} team{totalTeams === 1 ? '' : 's'} over capacity
          </span>
        </div>
      )}
      {teamsOverCapacity === 0 && totalTeams > 0 && !isLoading && (
        <span className="text-muted-foreground">
          {totalTeams} team{totalTeams === 1 ? '' : 's'} within capacity
        </span>
      )}
    </div>
  );
}
